import ReactDOM from 'react-dom';
import Chat from '@outdoor-voices/ui/dist/components/Chat';
import { jsx as _jsx } from "react/jsx-runtime";

var init = function init() {
  var el = document.createElement('div');
  document.body.appendChild(el);
  ReactDOM.render( /*#__PURE__*/_jsx(Chat, {}), el);
};

export default init;